import { connect } from 'react-redux';
import { selectActiveVenueId } from 'selectors/general';
import { openModal } from 'components/Modal';
import { selectSelectedScheduleInstance } from '../../Schedules.selectors';
import { cancelScheduleInstance } from '../../Schedules.saga';
import SchedulePreview from './SchedulePreview';

const mapStateToProps = state => ({
  selectedScheduleInstance: selectSelectedScheduleInstance(state),
  venueId: selectActiveVenueId(state),
});

const mapDispatchToProps = {
  openModal,
  cancelScheduleInstance,
};

export default connect(mapStateToProps, mapDispatchToProps)(SchedulePreview);
